import type { ReactElement } from 'react';

/**
 * The flame on a light's telling door. Shared by the two surfaces that hang a
 * tag (the Banyan and a place page's canopy band) so the door reads the same
 * on both; it takes its colour from the CSS around it.
 */
export function LabelFlame(): ReactElement {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden><path d="M12.5 3c.3 3.2 2.6 4.8 4.1 6.9 1 1.4 1.4 2.8 1.4 4.3a6 6 0 0 1-12 0c0-2.4 1.2-4.2 2.8-5.8.1 1.6.8 2.7 2 3.3C10.4 9 11 5.6 12.5 3Z" /></svg>;
}
